export default "__VITE_ASSET__DH0upx7B__"